import React from "react";
import resources from "../../../../api/constants/resources";
import {
  useProductDetailPageType,
  useProductPageType,
} from "@hook/products/useProductPageTypeHandler";
import ProductsList from "@components/products/list/ProductsList";
import ProductsDetail from "@components/products/detail/ProductsDetail";
import axios from "axios";
import { seoSettingSSR } from "@api/seo";

const ProductHashPage = ({
  product,
  seoData,
  initialPage,
  userDevice,
  siteConfig,
}) => {
  const { isDetailPage, lastSlug } = useProductDetailPageType();

  return (
    <>
      {isDetailPage ? (
        <ProductsDetail
          seoData={seoData}
          product={product}
          userDevice={userDevice}
        />
      ) : (
        <ProductsList
          seoData={seoData}
          product={product}
          userDevice={userDevice}
          initialPage={initialPage}
          siteConfig={siteConfig}
        />
      )}
    </>
  );
};

export default ProductHashPage;

export const getServerSideProps = async (context) => {
  const { params } = context;

  const slug = Array.isArray(params?.slug)
    ? params.slug[0]
    : params?.slug || "";

  const hash = Array.isArray(params?.hash)
    ? params.hash[0]
    : params?.hash || "";

  // 1. 기존 잘못된 카테고리 URL 교정
  const exactRedirects = {
    "Paper-Shooping-Bag": "Paper-Shopping-Bag",
  };

  if (slug && exactRedirects[slug]) {
    return {
      redirect: {
        destination: `/products/${encodeURIComponent(
          exactRedirects[slug]
        )}/${encodeURIComponent(hash)}/`,
        permanent: true,
      },
    };
  }

  // 상품코드가 없으면 404
  if (!hash) {
    return {
      notFound: true,
    };
  }

  // 2. 상품 조회
  const body = new URLSearchParams();
  body.append("modes", "View");
  body.append("pcode", hash);

  try {
    const res = await axios.post(
      `${resources.PRODUCTS}`,
      body.toString(),
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );

    // 3. 상품이 존재하지 않으면 404
    if (
      res?.data?.Code !== "0000" ||
      !res?.data?.Data?.Row
    ) {
      return {
        notFound: true,
      };
    }

    const product = res.data.Data.Row;

    // delYn이 API에서 전달된다면 삭제 상품도 404
    if (product.delYn === "Y") {
      return {
        notFound: true,
      };
    }

    // 5. URL의 카테고리명과 실제 상품 ename 비교
    const productEname =
      product.ename || product.Ename;

    if (
      productEname &&
      productEname !== slug
    ) {
      return {
        redirect: {
          destination: `/products/${encodeURIComponent(
            productEname
          )}/${encodeURIComponent(hash)}/`,
          permanent: true,
        },
      };
    }

    // 6. 정상 상품에 대해서만 SEO 데이터 조회
    let seoData = null;

    try {
      if (slug) {
        const seoResponse = await seoSettingSSR(slug);
        seoData = seoResponse?.data?.Data ?? null;
      }
    } catch (error) {
      console.error(
        "SEO 데이터 가져오기 실패:",
        error
      );
    }

    // 7. 정상 상품
    return {
      props: {
        product: {
          ...product,
        },
        seoData: seoData || null,
      },
    };
  } catch (error) {
    console.error(
      "상품 상세 데이터 가져오기 실패:",
      error
    );

    return {
      notFound: true,
    };
  }
};